import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=f6f96e72&scoped=true&"
import script from "./Pedidos.vue?vue&type=script&lang=js&"
export * from "./Pedidos.vue?vue&type=script&lang=js&"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=f6f96e72&prod&lang=scss&"
import style1 from "./Pedidos.vue?vue&type=style&index=1&id=f6f96e72&prod&lang=scss&"
import style2 from "./Pedidos.vue?vue&type=style&index=2&id=f6f96e72&prod&scoped=true&lang=css&"
import style3 from "./Pedidos.vue?vue&type=style&index=3&id=f6f96e72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f96e72",
  null
  
)

export default component.exports